<template>
    <div class="flex justify-between text-center -mx-2 mt-4 p-4">
        <button v-if="tourCount" v-for="(tour, index) in tourCount" :key="tour"
                     @click.prevent="selectTour(getQuestionStandart(tour, index), getSerialNumber(tour, index), getDisplayedTour(tour, index))"
                     class="no-underline  py-2 tour-button mx-3 whitespace-no-wrap outline-none"
                     :class="{'selected-tour-button':serialNumber === getSerialNumber(tour, index)}"
        >{{getDisplayedNumber(tour, index)}} тур
        </button>
    </div>
</template>

<script>
export default {
  name: 'GameTourSwitch',
  props: ['id', 'template', 'serialNumber'],
  methods: {
    getQuestionStandart(tourNumber, index) {
      if (this.template) {
        if (this.template.start_from_zero) tourNumber = index;
        const tours = this.template.rules.tours;
        return tours.filter(tour => tour.id === tourNumber)[0].tour_id;
      }
      return tourNumber;
    },
    getSerialNumber(tourNumber, index) {
      if (this.template && this.template.start_from_zero) {
        return index;
      }
      return tourNumber;
    },
    getDisplayedNumber(tourNumber, index) {
      if (this.template &&
          this.template.rules &&
          this.template.rules.tours &&
          this.template.rules.tours.length > 0 &&
          this.template.rules.tours[index] &&
          this.template.rules.tours[index].displayed_number &&
          this.template.rules.tours[index].displayed_number.toString() !== tourNumber.toString()
      ) {
        const displayedNumber = this.template.rules.tours[index].displayed_number;
        return `${tourNumber} (${displayedNumber})`;
      }
      if (this.template && this.template.start_from_zero) {
        return index;
      }
      return tourNumber;
    },
    getDisplayedTour(tourNumber, index) {
      if (this.template &&
          this.template.rules &&
          this.template.rules.tours &&
          this.template.rules.tours.length > 0 &&
          this.template.rules.tours[index] &&
          this.template.rules.tours[index].displayed_number &&
          this.template.rules.tours[index].displayed_number.toString() !== tourNumber.toString()
      ) {
        return this.template.rules.tours[index].displayed_number;
      }
      return null;
    },
    selectTour(tourNumber, serialNumber, displayedTour) {
      this.$emit('tourSelected', tourNumber, serialNumber, displayedTour);
    },
  },
  computed: {
    tourCount() {
      return this.template ? this.template.tour_count : 7;
    },

  },
};
</script>

<style scoped lang="less">
    @tailwind utilities;

    .tour-button {
        width: 117px;
        height: 42px;
        border-radius: 21px;
        border: 1px #979797 solid;
        color: #979797;
        font-weight: 700;
        font-size: 15px;
        background-color: #ffffff;
        &:hover {
            background-color: #bd006c;
            color: #fff
        }
        &:focus {
            background-color: #bd006c;
            color: #fff
        }
    }

    .selected-tour-button {
        background-color: #bd006c;
        color: #fff
    }


</style>
